import { selectDocumentById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"

import { projectDocumentDetailsViewLayoutHandle } from "../../../../../../../../views/ProjectDocumentDetailsView/constants"
import { NotFound } from "../../../../../../../../views/ProjectDocumentDetailsView/NotFound"
import { ProjectDocumentDetailsView } from "../../../../../../../../views/ProjectDocumentDetailsView/ProjectDocumentDetailsView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/$documentId",
)({
	component: ProjectDocumentDetailsView,
	notFoundComponent: NotFound,
	staticData: projectDocumentDetailsViewLayoutHandle,
	loader: ({ params }) => {
		const document = selectDocumentById(params.documentId)(appStore.getState())
		if (!document) throw notFound()
	},
})
